export default function getMonthlyRate(rate) {
  return rate / 100 / 12;
}
